import orderOptimizerTranslationsHelper from "../../../../../languages/order-optimizer-translations.helper";
import OrderOptimizerCargoDetailsBeforeOptimizationTableColumn from "../common/types/order-optimizer-cargo-details-before-optimization-table-column";

const getColumns =
  (): OrderOptimizerCargoDetailsBeforeOptimizationTableColumn[] => {
    const translations =
      orderOptimizerTranslationsHelper.getCargoDetailsTranslations().table
        .beforeOptimization.headers;

    const tableColumns: OrderOptimizerCargoDetailsBeforeOptimizationTableColumn[] =
      [
        {
          header: translations.optimizationLabel,
          title: translations.optimizationTitle,
          accessor: "optimization",
          colSpan: 3,
        },
        {
          header: translations.billingModelLabel,
          title: translations.billingModelTitle,
          accessor: "billingModel",
          colSpan: 3,
        },
        {
          header: translations.totalTimeLabel,
          title: translations.totalTimeTitle,
          accessor: "totalTime",
          colSpan: 3,
        },
        {
          header: translations.haltingTimeLabel,
          title: translations.haltingTimeTitle,
          accessor: "haltingTime",
          colSpan: 3,
        },
        {
          header: translations.distanceLabel,
          title: translations.distanceTitle,
          accessor: "distance",
          colSpan: 3,
        },
        {
          header: translations.savingLabel,
          title: translations.savingTitle,
          accessor: "saving",
          colSpan: 4,
        },
      ];

    return tableColumns;
  };

const orderOptimizerCargoDetailsBeforeOptimizationTableHelper = {
  getColumns,
};

export default orderOptimizerCargoDetailsBeforeOptimizationTableHelper;
